import { Add, Remove } from "@mui/icons-material";
import { Box, useTheme } from "@mui/material";
import { FunctionComponent } from "react";
import "./style.scss";

interface NumberSelectorProps {
  value: number;
  onChange: (value: number) => void;
}

const NumberSelector: FunctionComponent<NumberSelectorProps> = ({
  onChange,
  value,
}) => {
  const theme = useTheme();

  return (
    <Box
      className="number-selector-container"
      sx={{ bgcolor: theme.palette.grey[200] }}
    >
      <Remove className="remove-icon" onClick={() => onChange(value - 1)} />
      {value}
      <Add className="add-icon" onClick={() => onChange(value + 1)} />
    </Box>
  );
};

export default NumberSelector;
